const PAGINATION_PARAMS = new Set(['page', 'limit']);

const splitFilterValues = (value) =>
	String(value ?? '')
		.split(',')
		.map((item) => item.trim())
		.filter(Boolean)
		.sort();

const sameFilterValues = (left, right) => {
	const a = splitFilterValues(left);
	const b = splitFilterValues(right);

	return a.length === b.length && a.every((item, index) => item === b[index]);
};

const isStatusFilterKey = (key) =>
	key === 'filter.status.op' || key === 'filter.status.value';

const isPostponedFilterKey = (key) => key.startsWith('filter.postponedUntil.');

export const isMenuUrlActive = (
	menuUrl,
	{ pathname = '', search = '' } = {},
) => {
	if (!menuUrl) return false;

	const url = new URL(menuUrl, 'http://local.invalid');
	if (url.pathname !== pathname) return false;

	const menuParams = url.searchParams;
	const currentParams = new URLSearchParams(search);
	const menuKeys = [...menuParams.keys()];

	if (menuKeys.length === 0) {
		for (const key of currentParams.keys()) {
			if (!PAGINATION_PARAMS.has(key)) return false;
		}
		return true;
	}

	const exactMatch = menuKeys.every((key) => {
		if (key === 'filter.status.value') {
			return sameFilterValues(
				currentParams.get(key),
				menuParams.get(key),
			);
		}

		return currentParams.get(key) === menuParams.get(key);
	});

	if (exactMatch) return true;

	const menuStatusOp = menuParams.get('filter.status.op');
	const menuStatusValue = menuParams.get('filter.status.value');
	const currentStatusOp = currentParams.get('filter.status.op');
	const currentStatusValue = currentParams.get('filter.status.value');

	if (
		menuStatusOp !== 'eq' ||
		currentStatusOp !== 'eq' ||
		!menuStatusValue ||
		!currentStatusValue
	) {
		return false;
	}

	const currentValues = splitFilterValues(currentStatusValue);
	const menuValues = splitFilterValues(menuStatusValue);

	if (currentValues.length !== 1) return false;
	if (!menuValues.includes(currentValues[0])) return false;

	const menuPostponedOp = menuParams.get('filter.postponedUntil.op');
	const currentPostponedOp = currentParams.get('filter.postponedUntil.op');

	if (menuPostponedOp && currentPostponedOp) {
		if (menuPostponedOp !== currentPostponedOp) return false;
		if (
			menuParams.get('filter.postponedUntil.value') !==
			currentParams.get('filter.postponedUntil.value')
		) {
			return false;
		}
	} else if (menuPostponedOp && !currentPostponedOp) {
		// Голый filter.status=postponed подсвечивает «Отложено» (ltDate), не «Пора связываться»
		if (menuPostponedOp !== 'ltDate') return false;
	}

	return menuKeys.every((key) => {
		if (isStatusFilterKey(key) || isPostponedFilterKey(key)) return true;

		return currentParams.get(key) === menuParams.get(key);
	});
};
